<template>
	<div class="mb-4">
		<div class="flex flex-wrap gap-2">
			<div>
				<vs-checkbox
					:checked="isFilterSelected('all')"
					@change="toggleFilter('all')"
				>
					Alles
				</vs-checkbox>
			</div>

			<div v-if="isBolModuleEnabled && hasBolOrders">
				<vs-checkbox
					:checked="isFilterSelected('bol')"
					@change="toggleFilter('bol')"
				>
					Bol
				</vs-checkbox>
			</div>

			<div v-if="isLightspeedModuleEnabled && hasLightspeedOrders">
				<vs-checkbox
					:checked="isFilterSelected('lightspeed')"
					@change="toggleFilter('lightspeed')"
				>
					Lightspeed
				</vs-checkbox>
			</div>

			<div v-if="hasVvvOrders">
				<vs-checkbox
					:checked="isFilterSelected('bol-vvv')"
					@change="toggleFilter('bol-vvv')"
				>
					Bol eigen verzending
				</vs-checkbox>
			</div>

			<div v-if="hasVvbOrders">
				<vs-checkbox
					:checked="isFilterSelected('bol-vvb')"
					@change="toggleFilter('bol-vvb')"
				>
					Bol VVB
				</vs-checkbox>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'filtermodules',
	data() {
		return {
			selectedFilters: ['all']
		}
	},
	computed: {
		isBolModuleEnabled() {
			return this.$store.state.dashboard.modules.webshops.bol;
		},
		isLightspeedModuleEnabled() {
			return this.$store.state.dashboard.modules.webshops.lightspeed;
		},
		hasVvvOrders() {
			return this.$store.state.openOrdersStore.metadata.has_open_bol_vvv;
		},
		hasVvbOrders() {
			return this.$store.state.openOrdersStore.metadata.has_open_bol_vvb;
		},
		hasBolOrders() {
			return this.$store.state.openOrdersStore.metadata.has_open_bol;
		},
		hasLightspeedOrders() {
			return this.$store.state.openOrdersStore.metadata.has_open_lightspeed;
		}
	},
	methods: {
		isFilterSelected(filterName) {
			return this.selectedFilters.includes(filterName);
		},
		toggleFilter(filterName) {
			if (this.selectedFilters.includes(filterName)) {
				this.selectedFilters = ['all'];
			} else {
				this.selectedFilters = [filterName];
			}

			this.$emit('filter-change', this.selectedFilters);
		},
		getSelectedFilters() {
			return this.selectedFilters;
		},
		resetFilters() {
			this.selectedFilters = ['all'];
			this.$emit('filter-change', this.selectedFilters);
		}
	}
}
</script>

<style scoped>
.gap-2 {
	gap: 0.5rem;
}
</style>
